import { useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import HomeOperacional from "@/pages/HomeOperacional";
import { Navigate } from "react-router-dom";

// Tela inicial montada conforme perfil + escopo.
// Perfil operacional de Recebimento/Unidade recebe a Home operacional simplificada;
// demais perfis recebem o Painel (com escopo A/B/C definido no próprio Dashboard).
export default function Home() {
  const { user } = useAuth();
  if (user.role === "TRANSPORTE") return <Navigate to="/cargas" replace />;
  if (user.role === "UNIDADE") return <HomeOperacional />;
  return <Dashboard />;
}
